"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _excluded = ["className"];

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Meta = _antd.Card.Meta;

var CardWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  .ant-card,\n  .ant-card-head,\n  .action-card .ant-card-actions {\n    border-color: ", ";\n  }\n  .ant-card-head-title,\n  .ant-card-meta-title {\n    font-size: ", ";\n    line-height: 24px;\n    color: ", ";\n  }\n  .ant-card-extra {\n    font-size: ", ";\n    line-height: 20px;\n    color: ", ";\n  }\n  .ant-card-body {\n    padding: 16px 24px;\n  }\n  .ant-card-meta-description,\n  .card-content {\n    font-size: ", ";\n    line-height: 20px;\n    color: ", ";\n  }\n  .cover-card,\n  .action-card {\n    .ant-card-head {\n      min-height: 0;\n      max-height: 0;\n      border: 0;\n    }\n    .ant-card-body {\n      padding: 24px;\n    }\n  }\n  .basic-card,\n  .cover-card,\n  .small-card,\n  .inner-card {\n    .ant-card-actions {\n      display: none;\n    }\n  }\n  .small-card {\n    .ant-card-head {\n      min-height: 38px;\n    }\n    .ant-card-head-title,\n    .ant-card-extra {\n      padding: 8px 0;\n      font-size: ", ";\n      line-height: 22px;\n    }\n  }\n  .inner-card {\n    .ant-card-head {\n      background: ", ";\n    }\n    .ant-card-head-title,\n    .ant-card-extra {\n      font-size: ", ";\n      line-height: 22px;\n    }\n  }\n  .action-card {\n    .ant-card-actions {\n      & > {\n        li {\n          margin: 8px 0;\n          & > {\n            span {\n              color: ", ";\n              &:hover {\n                color: ", ";\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])), _theme.theme.colors.grey, _theme.theme.font_size.size_xl, _theme.theme.colors.black_secondary, _theme.theme.font_size.size_l, _theme.theme.colors.anchor_blue, _theme.theme.font_size.size_l, _theme.theme.colors.grey_secondary, _theme.theme.font_size.size_l, _theme.theme.colors.light_grey, _theme.theme.font_size.size_l, _theme.theme.colors.grey_tertiary, _theme.theme.colors.grey_tertiary);

var Flex = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: Flex;\n  align-items: center;\n  .anticon {\n    width: 33.33%;\n    min-height: 24px;\n    border-right: 1px solid ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: ", ";\n    &:last-of-type {\n      border-right: 0;\n    }\n  }\n"])), _theme.theme.colors.grey, _theme.theme.icon_size.icon_2xl);

var Actions = function Actions() {
  return /*#__PURE__*/_react.default.createElement(Flex, null, /*#__PURE__*/_react.default.createElement(_icons.SettingOutlined, {
    key: "setting"
  }), /*#__PURE__*/_react.default.createElement(_icons.EditOutlined, {
    key: "edit"
  }), /*#__PURE__*/_react.default.createElement(_icons.EllipsisOutlined, {
    key: "ellipsis"
  }));
};

function CardAnt(props) {
  var className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement(CardWrapper, null, /*#__PURE__*/_react.default.createElement(_antd.Card, _extends({
    title: props.title ? props.title : null,
    extra: /*#__PURE__*/_react.default.createElement("a", {
      href: "/"
    }, props.extraText),
    cover: props.cover ? /*#__PURE__*/_react.default.createElement("img", {
      alt: props.altText,
      src: props.imgUrl
    }) : null,
    actions: [props.action ? /*#__PURE__*/_react.default.createElement(Actions, null) : null],
    className: className
  }, rest), props.cover ? /*#__PURE__*/_react.default.createElement(Meta, {
    title: props.metaTitle,
    description: props.metaDescription,
    avatar: props.avatar ? /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
      src: props.imgUrl
    }) : null
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "card-content"
  }, props.cardContent)));
}

var _default = CardAnt;
exports.default = _default;